/** Poll interval for SWR hooks that fetch day parts and layouts */
export const SDM_SWR_REFRESH_INTERVAL_MS = 600_000;

/** Service Display Debugger panel resize bounds (px) */
export const DEBUGGER_PANEL_INITIAL_WIDTH_PX = 400;
export const DEBUGGER_PANEL_MIN_WIDTH_PX = 200;
export const DEBUGGER_PANEL_MAX_WIDTH_PX = 800;
/** Number of cells in our grid, both horizontally and vertically. */
export const GRID_SIZE = 100;

export const MAX_WIDGETS_PER_LAYOUT = 9;
/** Live feed widgets hold open WebRTC connections, so a layout may only contain a couple. */
export const MAX_LIVE_FEED_WIDGETS_PER_LAYOUT = 2;
/** How long each camera stays on screen before a live feed widget rotates to the next one. */
export const DEFAULT_LIVE_FEED_ROTATION_SECONDS = 5;
/**
 * The next camera connects in the background while the current one plays, so rotating faster
 * than a WHEP handshake takes would put feeds on screen before they have started.
 */
export const MIN_LIVE_FEED_ROTATION_SECONDS = 2;
export const MAX_LIVE_FEED_ROTATION_SECONDS = 60;
/** How often a live feed widget re-fetches its site to pick up camera status changes. */
export const LIVE_FEED_CAMERA_STATUS_REFRESH_INTERVAL_MS = 30_000;
export const SDM_ROUTE = '/ai-service-display';
export const SDM_CONFIG_ROUTE = '/ai-service-display/configure';

export const DEFAULT_COUNT_THRESHOLD = 10;
export const DEFAULT_TIME_THRESHOLD_SECONDS = 120;
export const FIXED_DRIVE_OFF_THRESHOLD = 1;

export const ICON_SIZE = 16;

export const SDM_THEME_QUERY_PARAM = 'theme';
export const SDM_THEME_QUERY_VALUE_DARK = 'dark';
export const SDM_LAYOUT_QUERY_PARAM = 'layoutId';

/** Used in DayPartsScheduleView */
export const DAY_PART_WEEK_INDEX = 7;
export const HOURS_IN_DAY = 24;
export const DEFAULT_SCROLL_TO_HOUR = 5;
export const DAY_PART_GRID_PREFIX = 'start-hour';
export const CELL_HEIGHT_PX = 60; // 60px = 60 minutes → 1px per minute, used for card positioning

/** ShadCN Sidebar width overrides used in the SidebarProvider */
export const DAY_PART_SIDEBAR_WIDTH = 320;
export const DAY_PART_SIDEBAR_WIDTH_WEEK = 602;
export const DAY_PART_SIDEBAR_MIN_WIDTH = 320;
export const DAY_PART_SIDEBAR_MAX_WIDTH = 602;
export const DAY_PART_SIDEBAR_COLLAPSED_WIDTH = 56;

/** Uppercase is intentional for Mixpanel tracking to show "SDM Logout" vs. "Sdm Logout" */
export const SDM_EVENTS = {
  LOGOUT: 'SDM-logout',
  EDIT_LAYOUT: 'SDM-edit-layout',
  CREATE_WIDGET: 'SDM-create-widget',
  SAVE_LAYOUT: 'SDM-saved-layout',
  CANCEL_EDIT: 'SDM-cancel-layout-editing',
  OPEN: 'SDM-open',
  CONFIGURE_WIDGET: 'SDM-configure-widget',
  DELETE_WIDGET: 'SDM-delete-widget',
  RESET_WIDGET: 'SDM-reset-widget',
  SAVE_WIDGET: 'SDM-save-widget',
  OPEN_TEMPLATE_PICKER: 'SDM-open-template-picker',
  SELECT_TEMPLATE: 'SDM-select-template',
  SELECT_BLANK_LAYOUT: 'SDM-select-blank-layout',
  ADOPTION_SNAPSHOT: 'SDM-adoption-snapshot',
  LAYOUT_SNAPSHOT: 'SDM-layout-snapshot',
  DELETE_LAYOUT: 'SDM-delete-layout',
  CREATE_DAY_PART: 'SDM-create-day-part',
  UPDATE_DAY_PART: 'SDM-update-day-part',
  DELETE_DAY_PART: 'SDM-delete-day-part',
  LIVE_FEED_ERROR: 'SDM-live-feed-error',
} as const;

/** Widget constants */
export const IGNORE_THRESHOLD_WARNING = 0;
